export function createColumns (columns) {
  if (!columns || !columns.length) {
    return null
  }
  return columns.reduce((obj, col) => {
    if (col.fixed === 'right') {
      obj.fixedRightColumns.push(col)
    } else if (col.fixed === 'left' || col.fixed === true) {
      obj.fixedLeftColumns.push(col)
    } else {
      obj.normalColumns.push(col)
    }
    return obj
  }, {
    fixedLeftColumns: [],
    fixedRightColumns: [],
    normalColumns: []
  })
}

export function createExpandRowColumnCells (h, {columns, mainColumns, currentSize}, expandRowCallBack) {
  if (!mainColumns || !mainColumns.length) {
    return null
  }
  const {
    fixedLeftColumns,
    fixedRightColumns
  } = createColumns(columns)
  const colspan = fixedRightColumns.length ? columns.length - fixedRightColumns.length : columns.length
  return [
    ...fixedLeftColumns.map(_ => <td></td>),
    <td colspan={colspan} style={{height: currentSize + 'px'}}>
      {
        expandRowCallBack()
      }
    </td>,
     ...fixedRightColumns.map(_ => <td></td>),
  ]
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/expand-row.js